/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface KorabSkillStats { 
    item: string;
    /**
     * Počet záznamů (činností) s touto dovedností.
     */
    activities: number;
    /**
     * Nejvyšší splněná úroveň 0–3; u třídy průměr přes aktivní děti.
     */
    level: number;
    /**
     * Počet dětí na úrovni 1, 2 a 3.
     */
    levelCounts: Array<number>;
}